import { z } from "zod";

export const VariableSchema = z.object({
  id: z.number().positive().min(1),
  name: z.string(),
  unit: z.string().nullable().optional(),
  constraintText: z.string().nullable().optional(),
  createdOn: z.date(),
  modifiedOn: z.date(),
  createdBy: z.number().positive().min(1),
  modifiedBy: z.number().positive().min(1),
  active: z.boolean(),
  isLookup: z.boolean(),
  lookupTableId: z.number().positive().min(1).nullable().optional(),
});

export type Variable = z.infer<typeof VariableSchema>;